import { motion } from 'framer-motion'

import { cn } from '../../lib/utils'
import { fadeInVariants, listContainerVariants, listItemVariants } from '../../lib/motion'

export function AnimatedSearchStatus({ children, className }) {
  return (
    <motion.div
      className={cn('max-h-[50vh] flex justify-center items-center text-primary-500', className)}
      variants={fadeInVariants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      {children}
    </motion.div>
  )
}

export function AnimatedSearchList({ children, className, motionKey }) {
  return (
    <motion.div
      key={motionKey}
      className={cn('max-h-[70vh] overflow-y-scroll', className)}
      variants={listContainerVariants}
      initial='hidden'
      animate='visible'
      exit='exit'
    >
      {children}
    </motion.div>
  )
}

export function AnimatedSearchItem({ children, className, ...props }) {
  return (
    <motion.div
      className={cn('cursor-pointer', className)}
      variants={listItemVariants}
      whileTap={{ scale: 0.99 }}
      {...props}
    >
      {children}
    </motion.div>
  )
}
